import { Component } from '@angular/core';

@Component({
  selector: 'app-post-categories',
  imports: [],
  templateUrl: './post-categories.html',
  styleUrl: './post-categories.css',
})
export class PostCategories {

}
